// import React, { useEffect, useState } from "react";
// import HighlightOff from "@mui/icons-material/HighlightOff";
// import { useAuth } from "../App";
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   ListItemAvatar,
//   Button,
//   CircularProgress,
//   Link,
//   Grid,
//   Divider,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   DialogActions,
// } from "@mui/material";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import DownloadIcon from "@mui/icons-material/Download";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import AdminSidebar from "../AdminSidebar";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// // import IconButton from '@mui/icons-material/IconButton';
// import IconButton from "@mui/material/IconButton";
// import CloseIcon from "@mui/icons-material/Close";
// import EventScheduleModal from "../components/EventScheduleModal";
// import JobOrderEventsTable from "../components/JobOrderEventsTable";
// import Snackbar from "@mui/material/Snackbar";

// import { API_URL } from "../config";

// export default function JobOrderCandidates() {
//   // --- Snackbar State ---
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   const { fetchWithAuth } = useAuth();
//   // Modal state for file viewer (must be declared before anything that uses it)
//   const [modalFile, setModalFile] = useState(null);
//   // --- AI Resume Modal State ---
//   const [aiModalOpen, setAiModalOpen] = useState(false);
//   const [aiModalLoading, setAiModalLoading] = useState(false);
//   const [aiModalError, setAiModalError] = useState("");
//   const [aiModalJson, setAiModalJson] = useState(null);
//   const [analyzeLoading, setAnalyzeLoading] = useState(false);
//   const [analyzeError, setAnalyzeError] = useState("");
//   const [analyzeResult, setAnalyzeResult] = useState(null);
//   const [aiModalApplicant, setAiModalApplicant] = useState(null);
//   // State for Office doc viewer error fallback
//   const [docError, setDocError] = useState(false);
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [candidates, setCandidates] = useState([]);
//   // Map: application_id -> { status, loading, error }
//   const [aiEvalStatus, setAiEvalStatus] = useState({});

//   const [jobOrder, setJobOrder] = useState(null);
//   const [events, setEvents] = useState([]);

//   // State for selected application details
//   const [selectedApplication, setSelectedApplication] = useState(null);
//   const [applicationLoading, setApplicationLoading] = useState(false);
//   const [applicationError, setApplicationError] = useState("");
//   const [applicationAnswers, setApplicationAnswers] = useState([]);
//   const [answersLoading, setAnswersLoading] = useState(false);
//   const [answersError, setAnswersError] = useState("");

//   // Activity logs state
//   const [activityLogs, setActivityLogs] = useState([]);
//   const [activityLoading, setActivityLoading] = useState(false);
//   const [activityError, setActivityError] = useState("");

//   // Job order titles for activity logs (job_order_id -> title)
//   const [jobOrderTitles, setJobOrderTitles] = useState({});

//   // --- Event Scheduling Modal State ---
//   const [eventModalOpen, setEventModalOpen] = useState(false);
//   const [eventLoading, setEventLoading] = useState(false);
//   const [eventError, setEventError] = useState("");
//   const [eventSuccess, setEventSuccess] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [logActivityOpen, setLogActivityOpen] = useState(false);
//   const [activityType, setActivityType] = useState("note");
//   const [activityNotes, setActivityNotes] = useState("");
//   const [oldStatus, setOldStatus] = useState("");
//   const [newStatus, setNewStatus] = useState("");
//   const [statusOptions, setStatusOptions] = useState([]);
//   const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
//   const [statusOptionsError, setStatusOptionsError] = useState("");
//   const [logLoading, setLogLoading] = useState(false);
//   const [logError, setLogError] = useState("");

//   // Modal state for file viewer

//   // --- Log Activity Modal State ---

//   // Fetch events for the selected application/job order
//   useEffect(() => {
//     if (!selectedApplication) return;
//     setEvents([]);
//     fetchWithAuth(`${API_URL}/events/${selectedApplication.id}`)
//       .then((res) => (res.ok ? res.json() : []))
//       .then((data) => setEvents(Array.isArray(data) ? data : []))
//       .catch(() => setEvents([]));
//   }, [selectedApplication]);

//   // Fetch activity logs helper (must be defined before useEffect/handlers)
//   function fetchActivityLogs(applicationId) {
//     setActivityLoading(true);
//     setActivityError("");
//     fetchWithAuth(`${API_URL}/applications/${applicationId}/activity-logs`)
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to fetch activity logs");
//         return res.json();
//       })
//       .then((data) => setActivityLogs(data.activity_logs || data || []))
//       .catch((e) => {
//         setActivityError(e.message);
//         setActivityLogs([]);
//       })
//       .finally(() => setActivityLoading(false));
//   }

//   // (removed duplicate declaration of selectedApplication and related state hooks)

//   // Fetch job order titles for activity logs
//   useEffect(() => {
//     const missingIds = Array.from(
//       new Set(
//         activityLogs
//           .map((act) => act.job_order_id)
//           .filter((id) => id && !jobOrderTitles[id])
//       )
//     );
//     if (missingIds.length === 0) return;
//     Promise.all(
//       missingIds.map((id) =>
//         fetchWithAuth(`${API_URL}/job-orders/${id}`)
//           .then((res) => (res.ok ? res.json() : null))
//           .then((data) => ({ id, title: data?.title || `Job Order ${id}` }))
//           .catch(() => ({ id, title: `Job Order ${id}` }))
//       )
//     ).then((results) => {
//       setJobOrderTitles((prev) => {
//         const next = { ...prev };
//         results.forEach(({ id, title }) => {
//           next[id] = title;
//         });
//         return next;
//       });
//     });
//   }, [activityLogs, jobOrderTitles, API_URL]);

//   // Modal state for file viewer

//   // --- Event Scheduling Handlers ---
//   const handleOpenEventModal = () => {
//     setEventModalOpen(true);
//     setEventError("");
//     setEventSuccess("");
//   };
//   const handleCloseEventModal = () => {
//     setEventModalOpen(false);
//     setEventError("");
//     setEventSuccess("");
//   };
//   const handleScheduleEvent = (eventData) => {
//     setEventLoading(true);
//     setEventError("");
//     setEventSuccess("");
//     // Close modal and reset fields immediately on valid submit
//     setEventModalOpen(false);
//     // Async backend call
//     fetchWithAuth(`${API_URL}/events/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         ...eventData,
//         application_id: selectedApplication?.id,
//       }),
//     })
//       .then(async (res) => {
//         if (!res.ok) {
//           let detail = "Failed to schedule event";
//           try {
//             const data = await res.json();
//             if (data && data.detail) detail = data.detail;
//           } catch {
//             try {
//               const text = await res.text();
//               if (text) detail = text;
//             } catch {}
//           }
//           throw new Error(detail);
//         }
//         setEventSuccess("Event scheduled and invites sent!");
//       })
//       .catch((e) => {
//         setEventError(e.message || "Failed to schedule event");
//       })
//       .finally(() => {
//         setEventLoading(false);
//       });
//   };

//   // --- Log Activity Modal State ---

//   // ---- SELECTED CANDIDATE (must be after all useState, before any useEffect/handler that uses it) ----
//   const searchParams = new URLSearchParams(location.search);
//   const selectedId = searchParams.get("selected");
//   const selectedCandidate = candidates.find((c) => c.id === selectedId);

//   // Fetch statuses when logActivityOpen and activityType === 'status_change'
//   useEffect(() => {
//     async function fetchStatusOptions() {
//       setStatusOptionsLoading(true);
//       setStatusOptionsError("");
//       try {
//         const res = await fetchWithAuth(`${API_URL}/statuses/`);
//         if (!res.ok) throw new Error("Failed to fetch statuses");
//         const data = await res.json();
//         setStatusOptions(Array.isArray(data) ? data : data.statuses || []);
//       } catch (e) {
//         setStatusOptionsError(e.message || "Failed to fetch statuses");
//       } finally {
//         setStatusOptionsLoading(false);
//       }
//     }
//     if (
//       logActivityOpen &&
//       activityType === "status_change" &&
//       statusOptions.length === 0 &&
//       !statusOptionsLoading
//     ) {
//       fetchStatusOptions();
//     }
//   }, [logActivityOpen, activityType]);

//   // When opening log activity modal, set oldStatus from application
//   function handleOpenLogActivity() {
//     setActivityType("note");
//     setActivityNotes("");
//     setNewStatus("");
//     setLogError("");
//     setStatusOptions([]);
//     setStatusOptionsLoading(false);
//     setStatusOptionsError("");
//     setLogActivityOpen(true);
//   }

//   // Always sync oldStatus to latest selectedApplication.status when modal is open
//   useEffect(() => {
//     if (
//       logActivityOpen &&
//       selectedApplication &&
//       selectedApplication.status !== undefined
//     ) {
//       setOldStatus(selectedApplication.status);
//     }
//   }, [logActivityOpen, selectedApplication && selectedApplication.status]);

//   // Ensure selectedApplication is set to the full application details when a candidate is selected
//   useEffect(() => {
//     if (!selectedCandidate || !selectedCandidate.id) return;

//     setApplicationLoading(true);
//     setApplicationError("");
//     fetchWithAuth(`${API_URL}/applications/${selectedCandidate.id}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setSelectedApplication(data);
//       })
//       .catch((e) => {
//         setApplicationError(e.message);
//         setSelectedApplication(null);
//         console.error("Failed to fetch application:", e);
//       })
//       .finally(() => setApplicationLoading(false));
//   }, [selectedCandidate, API_URL]);

//   // Debug logs
//   useEffect(() => {}, [selectedCandidate, selectedApplication]);

//   // --- Log Activity Handler ---
//   async function handleLogActivity() {
//     if (!selectedCandidate || !selectedCandidate.id) return;
//     setLogLoading(true);
//     setLogError("");
//     try {
//       // 1. Log the activity
//       const res = await fetchWithAuth(
//         `${API_URL}/applications/${selectedCandidate.id}/activity-logs`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             activity_type: activityType,
//             notes: activityNotes,
//             old_status: oldStatus || undefined,
//             new_status: newStatus || undefined,
//           }),
//         }
//       );
//       if (!res.ok) {
//         const err = await res.json();
//         throw new Error(err.detail || "Failed to log activity");
//       }
//       // 2. If status_change and newStatus !== oldStatus, PATCH application
//       if (
//         activityType === "status_change" &&
//         newStatus &&
//         newStatus !== oldStatus
//       ) {
//         const patchRes = await fetchWithAuth(
//           `${API_URL}/applications/${selectedCandidate.id}`,
//           {
//             method: "PATCH",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );
//         if (!patchRes.ok) {
//           const err = await patchRes.json();
//           throw new Error(err.detail || "Failed to update application status");
//         }
//       }
//       // Refresh application/activity data
//       setLogActivityOpen(false);
//       setActivityType("note");
//       setActivityNotes("");
//       setOldStatus("");
//       setNewStatus("");
//       // Refetch application/activity
//       if (selectedCandidate && selectedCandidate.id) {
//         // Refresh application details
//         setApplicationLoading(true);
//         setApplicationError("");
//         fetchWithAuth(`${API_URL}/applications/${selectedCandidate.id}`)
//           .then((res) => res.json())
//           .then((data) => setSelectedApplication(data))
//           .catch((e) => setApplicationError(e.message))
//           .finally(() => setApplicationLoading(false));
//         // Refresh activity logs
//         fetchActivityLogs(selectedCandidate.id);
//       }
//     } catch (e) {
//       setLogError(e.message || "Failed to log activity");
//     } finally {
//       setLogLoading(false);
//     }
//   }

//   // Helper to render correct file viewer for modal
//   function renderFileViewer(file, docError, setDocError) {
//     if (!file || !file.url) {
//       return null;
//     }
//     let url = file.url;
//     // URL rewriting is now handled when opening the modal; do not rewrite here.
//     // Use url as-is.
//     // (If you want to be extra safe, you can still check, but all callers should now pass the correct URL.)

//     // Images
//     if (url.match(/\.(jpg|jpeg|png|gif)$/i)) {
//       return (
//         <img
//           src={url}
//           alt={file.name}
//           style={{
//             maxWidth: "100%",
//             maxHeight: "100%",
//             display: "block",
//             margin: "0 auto",
//           }}
//         />
//       );
//     }
//     // PDF
//     if (url.match(/\.(pdf)$/i)) {
//       return (
//         <iframe
//           src={url}
//           title={file.name}
//           style={{ width: "100%", height: "90vh", border: 0 }}
//         />
//       );
//     }
//     // Text/CSV
//     if (url.match(/\.(txt|csv)$/i)) {
//       return (
//         <iframe
//           src={url}
//           title={file.name}
//           style={{ width: "100%", height: "90vh", border: 0 }}
//         />
//       );
//     }
//     // Office Docs (doc, docx, ppt, pptx, xls, xlsx)
//     if (url.match(/\.(docx?|pptx?|xlsx?|xls|ppt)$/i)) {
//       if (docError) {
//         return (
//           <a href={url} download target="_blank" rel="noopener">
//             Download Office Document
//           </a>
//         );
//       }
//       const gviewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
//         url
//       )}&embedded=true`;
//       return (
//         <iframe
//           src={gviewUrl}
//           title={file.name}
//           style={{ width: "100%", height: "90vh", border: 0 }}
//           onError={() => setDocError(true)}
//         />
//       );
//     }
//     // Fallback: download link

//     return (
//       <a
//         href={url}
//         download
//         target="_blank"
//         rel="noopener"
//         onClick={(e) => e.stopPropagation()}
//       >
//         Download file
//       </a>
//     );
//   }

//   // Fetch application details and answers when selectedCandidate changes
//   useEffect(() => {
//     if (!selectedCandidate) {
//       setSelectedApplication(null);
//       setApplicationError("");
//       setApplicationAnswers([]);
//       setAnswersError("");
//       return;
//     }
//     setApplicationLoading(true);
//     setApplicationError("");
//     fetchWithAuth(`${API_URL}/applications/${selectedCandidate.id}`)
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to fetch application details");
//         return res.json();
//       })
//       .then((data) => {
//         setSelectedApplication(data);
//       })
//       .catch((e) => {
//         setApplicationError(e.message);
//         setSelectedApplication(null);
//       })
//       .finally(() => setApplicationLoading(false));
//     // Fetch answers
//     setAnswersLoading(true);
//     setAnswersError("");
//     fetchWithAuth(`${API_URL}/applications/${selectedCandidate.id}/answers`)
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to fetch application answers");
//         return res.json();
//       })
//       .then((data) => {
//         setApplicationAnswers(data.answers || []);
//       })
//       .catch((e) => {
//         setAnswersError(e.message);
//         setApplicationAnswers([]);
//       })
//       .finally(() => setAnswersLoading(false));
//   }, [selectedCandidate, API_URL]);

//   useEffect(() => {
//     async function fetchData() {
//       setLoading(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/job-orders/${id}`);
//         if (!res.ok) {
//           if (res.status === 403) {
//             setError(
//               "You are not authorized to perform this action. Please contact your system administrator."
//             );
//             return;
//           }
//           throw new Error("Failed to fetch job order");
//         }
//         const data = await res.json();
//         let jobData = data;
//         if (Array.isArray(data)) {
//           jobData = data.length > 0 ? data[0] : null;
//         }
//         setJobOrder(jobData || null);
//         setCandidates(
//           jobData && jobData.applications ? jobData.applications : []
//         );
//         console.debug("Loaded jobOrder:", jobData);
//         console.debug("Loaded applications:", jobData?.applications);
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchData();
//   }, [id]);

//   // Handler to update URL with selected candidate
//   const handleSelectCandidate = (candidateId) => {
//     const params = new URLSearchParams(location.search);
//     params.set("selected", candidateId);
//     navigate(`${location.pathname}?${params.toString()}`);
//   };

//   // Handler to clear selection
//   const handleClearSelection = () => {
//     const params = new URLSearchParams(location.search);
//     params.delete("selected");
//     navigate(
//       `${location.pathname.replace(/\/candidates$/, "")}?${params.toString()}`
//     );
//   };

//   // Reset docError when modalFile changes and is an Office doc
//   useEffect(() => {
//     if (
//       modalFile &&
//       modalFile.url &&
//       modalFile.url.match(/\.(docx?|pptx?|xlsx?|xls|ppt)$/i)
//     ) {
//       setDocError(false);
//     }
//   }, [modalFile]);

//   // Fetch activity logs when candidate changes
//   useEffect(() => {
//     if (selectedCandidate && selectedCandidate.id) {
//       fetchActivityLogs(selectedCandidate.id);
//     } else {
//       setActivityLogs([]);
//     }
//   }, [selectedCandidate]);

//   // Fetch activity logs helper
//   function fetchActivityLogs(applicationId) {
//     setActivityLoading(true);
//     setActivityError("");
//     fetchWithAuth(`${API_URL}/applications/${applicationId}/activity-logs`)
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to fetch activity logs");
//         // console.log(res.json());
//         return res.json();
//       })
//       .then((data) => setActivityLogs(data.activity_logs || data || []))
//       .catch((e) => {
//         setActivityError(e.message);
//         setActivityLogs([]);
//       })
//       .finally(() => setActivityLoading(false));
//   }

//   // --- Fetch AI evaluation only for the selected application and job order ---
//   // (Must be declared after all state and function declarations, just before return)
//   useEffect(() => {
//     if (!selectedApplication || !selectedApplication.id || !id) return;
//     const evalUrl = `${API_URL}/ai/evaluations/by-application-job/${selectedApplication.id}/${id}`;
//     setAiEvalStatus((prev) => ({
//       ...prev,
//       [selectedApplication.id]: {
//         ...(prev[selectedApplication.id] || {}),
//         loading: true,
//         error: "Loading .....",
//       },
//     }));
//     const fetcher = window.fetchWithAuth || fetchWithAuth || fetch;
//     fetcher(evalUrl)
//       .then(async (res) => {
//         if (!res.ok) {
//           let errMsg = `The resume is yet to be analysed `;
//           try {
//             const errData = await res.json();
//             errMsg = errData.detail || errMsg;
//           } catch {}
//           throw new Error(errMsg);
//         }
//         return res.json();
//       })
//       .then((data) => {
//         setAiEvalStatus((prev) => ({
//           ...prev,
//           [selectedApplication.id]: {
//             loading: false,
//             error: null,
//             status: data.evaluation ? data.evaluation.status : null,
//             match_score: data.evaluation ? data.evaluation.match_score : null,
//             strengths: data.evaluation ? data.evaluation.strengths : null,
//             weaknesses: data.evaluation ? data.evaluation.weaknesses : null,
//             summary: data.evaluation ? data.evaluation.summary : null,
//             missing_skills: data.evaluation
//               ? data.evaluation.missing_skills
//               : null,
//           },
//         }));
//       })
//       .catch((e) => {
//         setAiEvalStatus((prev) => ({
//           ...prev,
//           [selectedApplication.id]: {
//             loading: false,
//             error: e.message,
//             status: null,
//           },
//         }));
//         setSnackbar &&
//           setSnackbar({
//             open: true,
//             message: e.message || "Failed to fetch AI evaluation.",
//             severity: "error",
//           });
//       });
//   }, [selectedApplication, id, API_URL]);

//   // --- AI Resume Extraction and Analysis Logic (adapted from JobOrderDetail.js) ---
//   async function handleScreenWithAI(applicant, jobOrder) {
//     setAiModalApplicant(applicant);
//     setAiModalOpen(true);
//     setAiModalLoading(true);
//     setAiModalError("");
//     setAiModalJson(null);
//     setAnalyzeResult(null);
//     setAnalyzeError("");
//     try {
//       // --- Fetch resume from applicant.resume (preferred) ---
//       let resumeFileUrl = applicant.resume || null;
//       // If resumeFileUrl is a relative path, prepend the backend API URL
//       if (resumeFileUrl && resumeFileUrl.startsWith("/uploads")) {
//         const API_URL =
//           process.env.REACT_APP_API_URL || "http://localhost:8000";
//         resumeFileUrl = API_URL.replace(/\/$/, "") + resumeFileUrl;
//       }
//       // Fallback: check answers for file-type resume if not present
//       if (!resumeFileUrl) {
//         const answers = applicant.answers || {};
//         for (const key in answers) {
//           const ans = answers[key];
//           if (ans && ans.type === "file" && ans.value && ans.value.url) {
//             resumeFileUrl = ans.value.url;
//             break;
//           }
//         }
//       }
//       if (!resumeFileUrl)
//         throw new Error("No resume file found on applicant record.");
//       // Fetch the resume file (PDF or DOCX)
//       const res = await fetch(resumeFileUrl);
//       if (!res.ok) throw new Error("Failed to fetch resume file.");
//       const arrayBuffer = await res.arrayBuffer();
//       // Detect file type by extension
//       const ext = resumeFileUrl.split(".").pop().toLowerCase();
//       let plainResumeText = "";
//       if (ext === "pdf") {
//         const pdfjsLib = await import("pdfjs-dist/build/pdf");
//         pdfjsLib.GlobalWorkerOptions.workerSrc =
//           "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
//         const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
//         let text = "";
//         for (let i = 1; i <= pdf.numPages; i++) {
//           const page = await pdf.getPage(i);
//           const content = await page.getTextContent();
//           text += content.items.map((item) => item.str).join(" ") + "\n";
//         }
//         plainResumeText = text;
//       } else if (ext === "docx") {
//         let mammoth = window.mammoth;
//         if (!mammoth) {
//           mammoth = await new Promise((resolve, reject) => {
//             const script = document.createElement("script");
//             script.src = "/vendor/mammoth.browser.min.js";
//             script.onload = () => resolve(window.mammoth);
//             script.onerror = () =>
//               reject(
//                 new Error(
//                   "Failed to load mammoth from /vendor/mammoth.browser.min.js"
//                 )
//               );
//             document.body.appendChild(script);
//           });
//         }
//         const { value } = await mammoth.extractRawText({ arrayBuffer });
//         plainResumeText = value;
//       } else {
//         // Fallback: treat as plain text
//         plainResumeText = new TextDecoder().decode(arrayBuffer);
//       }
//       plainResumeText = plainResumeText
//         .replace(/\u00a0/g, " ")
//         .replace(/\u2013|\u2014/g, "-")
//         .replace(/\u201c|\u201d/g, '"')
//         .replace(/\u2018|\u2019/g, "'")
//         .replace(/\u2026/g, "...")
//         .replace(/\u00b7/g, "-")
//         .replace(/\r|\t/g, " ")
//         .replace(/\n{2,}/g, "\n")
//         .replace(/\s{2,}/g, " ")
//         .trim();
//       // Remove HTML tags from job description
//       function stripHtml(html) {
//         if (!html) return "";
//         return html
//           .replace(/<[^>]*>/g, "")
//           .replace(/\s+/g, " ")
//           .trim();
//       }
//       const jobDescription = stripHtml(jobOrder.job.description || "");
//       const jsonObj = {
//         resume_text: plainResumeText,
//         job_description: jobDescription,
//         application_id: applicant.id,
//         job_order_id: jobOrder.id,
//       };
//       setAiModalJson(jsonObj);
//     } catch (e) {
//       setAiModalError(e.message || "Failed to extract resume text.");
//     } finally {
//       setAiModalLoading(false);
//     }
//   }

//   async function handleSubmitAnalyze() {
//     if (!aiModalJson) return;
//     setAnalyzeLoading(true);
//     setAnalyzeError("");
//     setAnalyzeResult(null);
//     try {
//       const fetcher = window.fetchWithAuth || fetchWithAuth;
//       if (!fetcher) throw new Error("fetchWithAuth is not available");
//       const res = await fetcher(`${API_URL}/ai/analyze-resume-text/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(aiModalJson),
//       });
//       if (!res.ok) {
//         const err = await res.json();
//         throw new Error(err.detail || "Failed to analyze resume");
//       }
//       const data = await res.json();
//       setAnalyzeResult(data);
//       setAiEvalStatus((prev) => ({
//         ...prev,
//         [aiModalApplicant?.id]: {
//           ...prev[aiModalApplicant?.id],
//           loading: false,
//           status: "Pending",
//           match_score: data.match_score,
//         },
//       }));
//       setTimeout(() => setAiModalOpen(false), 200);
//       setSnackbar({
//         open: true,
//         message: "Resume analyzed successfully!",
//         severity: "success",
//       });
//     } catch (e) {
//       setAnalyzeError(e.message || "Failed to analyze resume");
//     } finally {
//       setAnalyzeLoading(false);
//     }
//   }

//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh", background: "#f7f7fa" }}>
//       <AdminSidebar selected="Job Orders" />
//       {/* Non-blocking spinner for background event scheduling */}
//       {eventLoading && (
//         <Box
//           sx={{
//             position: "fixed",
//             bottom: 32,
//             right: 32,
//             zIndex: 1300,
//             pointerEvents: "none",
//             display: "flex",
//             alignItems: "center",
//           }}
//         >
//           <CircularProgress size={32} color="primary" thickness={5} />
//           <Typography sx={{ ml: 2, color: "primary.main", fontWeight: 500 }}>
//             Scheduling event...
//           </Typography>
//         </Box>
//       )}
//       <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3 }}>
//         <Paper elevation={2} sx={{ p: 3 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
//             <Typography variant="h4" gutterBottom>
//               Candidates in Job Order
//             </Typography>
//             <Button
//               startIcon={<ArrowBackIcon />}
//               variant="outlined"
//               color="primary"
//               onClick={handleClearSelection}
//               sx={{ ml: 2 }}
//             >
//               Back
//             </Button>
//           </Box>

//           {jobOrder && (
//             <Paper sx={{ p: 2, mb: 3 }}>
//               <Typography variant="h6">{jobOrder.title}</Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {/* {jobOrder.company_name} &mdash; {jobOrder.locations.join(", ")} */}
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}>
//                   {(jobOrder.locations && jobOrder.locations.length > 0
//                     ? jobOrder.locations
//                     : jobOrder?.locations && jobOrder?.locations.length > 0
//                     ? jobOrder?.locations
//                     : []
//                   ).length > 0 ? (
//                     (jobOrder.locations && jobOrder.locations.length > 0
//                       ? jobOrder.locations
//                       : jobOrder?.locations || []
//                     ).map((loc, idx) => (
//                       <Chip
//                         key={loc.id || loc.name || idx}
//                         label={loc.name}
//                         color={
//                           [
//                             "primary",
//                             "secondary",
//                             "success",
//                             "warning",
//                             "info",
//                             "error",
//                           ][idx % 6]
//                         }
//                         variant="filled"
//                       />
//                     ))
//                   ) : (
//                     <Chip label="-" color="default" variant="outlined" />
//                   )}
//                 </Box>
//               </Typography>
//             </Paper>
//           )}
//           {/* Candidate Details Panel */}
//           {selectedCandidate && (
//             <Paper
//               sx={{
//                 p: 3,
//                 mb: 2,
//                 background: "#f9f9f9",
//                 border: "1px solid #e0e0e0",
//               }}
//             >
//               <React.Fragment>
//                 {/* Log Activity Modal State */}
//                 {applicationLoading ? (
//                   <Box
//                     sx={{ display: "flex", justifyContent: "center", py: 4 }}
//                   >
//                     <CircularProgress />
//                   </Box>
//                 ) : applicationError ? (
//                   <Typography color="error">{applicationError}</Typography>
//                 ) : selectedApplication ? (
//                   <>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={4}>
//                         <Typography variant="h5" fontWeight={700}>
//                           Candidate Details
//                         </Typography>
//                         <Typography>
//                           <b>Name:</b>
//                         </Typography>
//                         <Typography>
//                           {selectedCandidate.applicant_name}
//                         </Typography>
//                         <br />
//                         <Typography>
//                           <b>Email:</b>
//                         </Typography>
//                         <Typography>
//                           {selectedCandidate.applicant_email}
//                         </Typography>
//                         <br />
//                         <Typography>
//                           <b>Phone Number:</b>
//                         </Typography>
//                         <Typography>{selectedCandidate.phone}</Typography>
//                         <br />
//                         <Typography>
//                           <b>Resume:</b>
//                         </Typography>
//                         <Typography>
//                           {selectedCandidate.resume &&
//                           typeof selectedCandidate.resume === "string" &&
//                           selectedCandidate.resume.startsWith("/uploads/") ? (
//                             <Button
//                               startIcon={<DownloadIcon />}
//                               sx={{ fontWeight: 700, mb: 1 }}
//                               size="small"
//                               onClick={() => {
//                                 const backendOrigin =
//                                   process.env.REACT_APP_API_URL ||
//                                   "http://localhost:8000";
//                                 let url = selectedCandidate.resume;
//                                 if (url && url.startsWith("/uploads/")) {
//                                   url = backendOrigin.replace(/\/$/, "") + url;
//                                 }
//                                 setModalFile({ url, name: "Resume" });
//                                 setModalOpen(true);
//                               }}
//                             >
//                               Download
//                             </Button>
//                           ) : selectedCandidate.resume ? (
//                             selectedCandidate.resume
//                           ) : (
//                             <em>None</em>
//                           )}
//                         </Typography>
//                         <br />
//                         <br />
//                         <br />
//                         {/* Log Activity Button */}
//                         <Box>
//                           <Button
//                             variant="contained"
//                             size="small"
//                             onClick={() => setLogActivityOpen(true)}
//                           >
//                             Log Activity
//                           </Button>
//                         </Box>
//                         {/* Log Activity Modal */}
//                         {/* Extract these fields from questions_answers in selectedApplication */}
//                       </Grid>
//                       <Grid item xs={12} md={8}>
//                         <Typography variant="h5" fontWeight={700}>
//                           AI Analysis:
//                         </Typography>
//                         {/* Show AI evaluation details for this candidate */}
//                         {(() => {
//                           const evalObj = aiEvalStatus[selectedApplication.id];
//                           // Show Analyze Resume button if error is 404 or 'not yet analyzed', or no evalObj
//                           if (
//                             !evalObj ||
//                             (evalObj.error &&
//                               (evalObj.error.includes("yet to be analysed") ||
//                                 evalObj.error.includes("404")))
//                           ) {
//                             return (
//                               <Box sx={{ mt: 2, mb: 2 }}>
//                                 <Button
//                                   variant="contained"
//                                   color="secondary"
//                                   onClick={() =>
//                                     handleScreenWithAI(
//                                       selectedApplication,
//                                       jobOrder
//                                     )
//                                   }
//                                   disabled={aiModalLoading}
//                                 >
//                                   {aiModalLoading ? (
//                                     <CircularProgress size={20} />
//                                   ) : (
//                                     "Analyze Resume"
//                                   )}
//                                 </Button>
//                                 {evalObj && evalObj.error && (
//                                   <Typography
//                                     color="error"
//                                     variant="body2"
//                                     sx={{ mt: 1 }}
//                                   >
//                                     {evalObj.error}
//                                   </Typography>
//                                 )}
//                               </Box>
//                             );
//                           }
//                           if (evalObj.loading) {
//                             return (
//                               <CircularProgress
//                                 size={20}
//                                 sx={{ mt: 1, mb: 1 }}
//                               />
//                             );
//                           }
//                           if (evalObj.error) {
//                             return (
//                               <Typography
//                                 color="error"
//                                 variant="body2"
//                                 sx={{ mt: 1, mb: 1 }}
//                               >
//                                 Error: {evalObj.error}
//                               </Typography>
//                             );
//                           }
//                           if (!evalObj.status || evalObj.status === "pending") {
//                             return (
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                                 sx={{ mt: 1, mb: 1 }}
//                               >
//                                 No evaluation available.
//                               </Typography>
//                             );
//                           }
//                           // Color for score: green >=4, yellow 2-3, red <2
//                           let scoreColor = "#388e3c";
//                           if (typeof evalObj.match_score === "number") {
//                             if (evalObj.match_score >= 4)
//                               scoreColor = "#388e3c";
//                             else if (evalObj.match_score >= 2)
//                               scoreColor = "#FFA500";
//                             else scoreColor = "#d32f2f";
//                           }
//                           return (
//                             <Box
//                               sx={{
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: 2,
//                                 p: 2,
//                                 background: "#fafbfc",
//                                 mt: 1,
//                                 mb: 1,
//                               }}
//                             >
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   mb: 1,
//                                 }}
//                               >
//                                 <Typography variant="h5" sx={{ mr: 1 }}>
//                                   Match Score:
//                                 </Typography>
//                                 <Box
//                                   sx={{
//                                     px: 2,
//                                     py: 0.5,
//                                     borderRadius: 2,
//                                     fontWeight: 700,
//                                     color: scoreColor,
//                                     border: `2px solid ${scoreColor}`,
//                                     display: "inline-block",
//                                     minWidth: 32,
//                                     textAlign: "center",
//                                     background:
//                                       scoreColor === "#388e3c"
//                                         ? "#e8f5e9"
//                                         : scoreColor === "#FFA500"
//                                         ? "#fff8e1"
//                                         : "#ffebee",
//                                   }}
//                                 >
//                                   {typeof evalObj.match_score === "number"
//                                     ? evalObj.match_score
//                                     : "NA"}
//                                 </Box>
//                               </Box>
//                               {evalObj.strengths && (
//                                 <Box sx={{ mb: 1 }}>
//                                   <Typography
//                                     variant="h6"
//                                     color="#388e3c"
//                                     sx={{ fontWeight: 700, mb: 1 }}
//                                   >
//                                     Strengths:
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     sx={{ whiteSpace: "pre-line" }}
//                                   >
//                                     {evalObj.strengths}
//                                   </Typography>
//                                 </Box>
//                               )}
//                               {evalObj.weaknesses && (
//                                 <Box sx={{ mb: 1 }}>
//                                   <Typography
//                                     variant="h6"
//                                     color="#d32f2f"
//                                     sx={{ fontWeight: 700, mt: 2, mb: 1 }}
//                                   >
//                                     Weaknesses:
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     sx={{ whiteSpace: "pre-line" }}
//                                   >
//                                     {evalObj.weaknesses}
//                                   </Typography>
//                                 </Box>
//                               )}
//                               {evalObj.summary && (
//                                 <Box sx={{ mb: 1 }}>
//                                   <Typography
//                                     variant="h6"
//                                     color="#1976d2"
//                                     sx={{ fontWeight: 700, mt: 2, mb: 1 }}
//                                   >
//                                     Summary:
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     sx={{ whiteSpace: "pre-line" }}
//                                   >
//                                     {evalObj.summary}
//                                   </Typography>
//                                 </Box>
//                               )}
//                               {evalObj.missing_skills &&
//                                 evalObj.missing_skills.length > 0 && (
//                                   <Box sx={{ mb: 1 }}>
//                                     <Typography
//                                       variant="h6"
//                                       color="#1976d2"
//                                       sx={{ fontWeight: 700, mt: 2, mb: 1 }}
//                                     >
//                                       Missing Skills:
//                                     </Typography>
//                                     <List dense sx={{ pl: 2 }}>
//                                       {evalObj.missing_skills.map(
//                                         (skill, idx) => (
//                                           <ListItem key={idx} sx={{ py: 0.5 }}>
//                                             <ListItemIcon sx={{ minWidth: 32 }}>
//                                               <HighlightOff
//                                                 color="error"
//                                                 fontSize="small"
//                                               />
//                                             </ListItemIcon>
//                                             <ListItemText
//                                               primary={skill}
//                                               primaryTypographyProps={{
//                                                 variant: "body2",
//                                               }}
//                                             />
//                                           </ListItem>
//                                         )
//                                       )}
//                                     </List>
//                                   </Box>
//                                 )}
//                             </Box>
//                           );
//                         })()}
//                       </Grid>
//                     </Grid>
//                     <Divider sx={{ my: 2 }} />

//                     <Divider sx={{ my: 2 }} />
//                     <Typography variant="subtitle2">Misc. Notes:</Typography>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ mb: 2 }}
//                     >
//                       {selectedApplication?.notes || "No notes."}
//                     </Typography>
//                     <Divider sx={{ my: 2 }} />
//                     <Typography variant="h6">
//                       Job Orders for Candidate:
//                     </Typography>
//                     <TableContainer component={Paper} sx={{ mb: 2 }}>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow>
//                             <TableCell>Title</TableCell>
//                             <TableCell>Company</TableCell>
//                             <TableCell>Status</TableCell>
//                             <TableCell>Date Applied</TableCell>
//                             <TableCell>AI Evaluation Status</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           <TableRow>
//                             <TableCell>{jobOrder.title}</TableCell>
//                             <TableCell>{jobOrder.department}</TableCell>
//                             <TableCell>
//                               <Chip
//                                 label={selectedCandidate.status}
//                                 size="small"
//                               />
//                             </TableCell>
//                             <TableCell>
//                               {jobOrder.created ? (
//                                 new Date(jobOrder.created).toLocaleString()
//                               ) : (
//                                 <em>Unknown</em>
//                               )}
//                             </TableCell>
//                           </TableRow>
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                     <Divider sx={{ my: 2 }} />
//                     <Typography variant="h6">Activity:</Typography>
//                     {/* Log Activity Button */}
//                     {/* Log Activity Button */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         mb: 2,
//                       }}
//                     >
//                       <Button
//                         variant="contained"
//                         size="small"
//                         onClick={() => setLogActivityOpen(true)}
//                       >
//                         Log Activity
//                       </Button>
//                     </Box>
//                     {/* Log Activity Modal */}
//                     <Dialog
//                       open={logActivityOpen}
//                       onClose={() => setLogActivityOpen(false)}
//                       maxWidth="sm"
//                       fullWidth
//                     >
//                       <DialogTitle>
//                         Log Activity for{" "}
//                         {selectedCandidate?.applicant_name || "Candidate"}
//                       </DialogTitle>
//                       <DialogContent dividers>
//                         <Box
//                           sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: 2,
//                           }}
//                         >
//                           <FormControl fullWidth>
//                             <InputLabel id="activity-type-label">
//                               Activity Type
//                             </InputLabel>
//                             <Select
//                               labelId="activity-type-label"
//                               value={activityType}
//                               label="Activity Type"
//                               onChange={(e) => setActivityType(e.target.value)}
//                               size="small"
//                             >
//                               <MenuItem value="note">Note</MenuItem>
//                               <MenuItem value="status_change">
//                                 Status Change
//                               </MenuItem>
//                               <MenuItem value="email">Email</MenuItem>
//                               <MenuItem value="call">Call</MenuItem>
//                               <MenuItem value="meeting">Meeting</MenuItem>
//                             </Select>
//                           </FormControl>
//                           {activityType === "status_change" && (
//                             <Box sx={{ display: "flex", gap: 2 }}>
//                               <TextField
//                                 label="Old Status"
//                                 value={oldStatus}
//                                 size="small"
//                                 fullWidth
//                                 InputProps={{ readOnly: true }}
//                               />
//                               <FormControl fullWidth size="small">
//                                 <InputLabel id="new-status-label">
//                                   New Status
//                                 </InputLabel>
//                                 <Select
//                                   labelId="new-status-label"
//                                   value={newStatus}
//                                   label="New Status"
//                                   onChange={(e) => setNewStatus(e.target.value)}
//                                   disabled={statusOptionsLoading}
//                                   error={!!statusOptionsError}
//                                 >
//                                   {statusOptionsLoading ? (
//                                     <MenuItem value="" disabled>
//                                       <CircularProgress
//                                         size={18}
//                                         sx={{ mr: 1 }}
//                                       />{" "}
//                                       Loading...
//                                     </MenuItem>
//                                   ) : statusOptionsError ? (
//                                     <MenuItem value="" disabled>
//                                       {statusOptionsError}
//                                     </MenuItem>
//                                   ) : (
//                                     statusOptions.map((status) => (
//                                       <MenuItem
//                                         key={
//                                           status.id ||
//                                           status.value ||
//                                           status.name
//                                         }
//                                         value={
//                                           status.value ||
//                                           status.name ||
//                                           status.id
//                                         }
//                                       >
//                                         {status.label ||
//                                           status.name ||
//                                           status.value}
//                                       </MenuItem>
//                                     ))
//                                   )}
//                                 </Select>
//                               </FormControl>
//                             </Box>
//                           )}
//                           <TextField
//                             label="Notes"
//                             value={activityNotes}
//                             onChange={(e) => setActivityNotes(e.target.value)}
//                             size="small"
//                             fullWidth
//                             multiline
//                             minRows={2}
//                             maxRows={6}
//                           />
//                           {logError && (
//                             <Typography color="error">{logError}</Typography>
//                           )}
//                         </Box>
//                       </DialogContent>
//                       <DialogActions>
//                         <Button
//                           onClick={() => setLogActivityOpen(false)}
//                           disabled={logLoading}
//                         >
//                           Cancel
//                         </Button>
//                         <Button
//                           onClick={handleLogActivity}
//                           variant="contained"
//                           disabled={logLoading}
//                         >
//                           {logLoading ? (
//                             <CircularProgress size={20} />
//                           ) : (
//                             "Log Activity"
//                           )}
//                         </Button>
//                       </DialogActions>
//                     </Dialog>

//                     {activityLoading ? (
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "center",
//                           py: 2,
//                         }}
//                       >
//                         <CircularProgress size={20} />
//                       </Box>
//                     ) : activityError ? (
//                       <Typography color="error">{activityError}</Typography>
//                     ) : activityLogs && activityLogs.length > 0 ? (
//                       <TableContainer component={Paper} sx={{ mb: 2 }}>
//                         <Table size="small">
//                           <TableHead>
//                             <TableRow>
//                               <TableCell>Date</TableCell>
//                               <TableCell>Type</TableCell>
//                               <TableCell>Regarding</TableCell>
//                               <TableCell>Notes</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {activityLogs.map((act, idx) => (
//                               <TableRow key={idx}>
//                                 <TableCell>
//                                   {act.created_at ? (
//                                     new Date(act.created_at).toLocaleString()
//                                   ) : (
//                                     <em>Unknown</em>
//                                   )}
//                                 </TableCell>
//                                 <TableCell>
//                                   {act.activity_type || act.type}
//                                 </TableCell>
//                                 <TableCell>{jobOrder.title}</TableCell>
//                                 <TableCell>
//                                   {act.activity_type === "status_change" &&
//                                   (act.new_status || act.old_status)
//                                     ? `Status changed from ${
//                                         act.old_status || ""
//                                       } to ${act.new_status || ""} ${
//                                         act.notes ? `: ${act.notes}` : ""
//                                       }`
//                                     : act.notes}
//                                 </TableCell>
//                               </TableRow>
//                             ))}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No activity found.
//                       </Typography>
//                     )}
//                     <Divider sx={{ my: 2 }} />
//                     <Typography variant="subtitle2">
//                       Questions & Answers:
//                     </Typography>
//                     <React.Fragment>
//                       {answersLoading ? (
//                         <Box
//                           sx={{
//                             display: "flex",
//                             justifyContent: "center",
//                             py: 2,
//                           }}
//                         >
//                           <CircularProgress size={20} />
//                         </Box>
//                       ) : answersError ? (
//                         <Typography color="error">{answersError}</Typography>
//                       ) : applicationAnswers &&
//                         applicationAnswers.length > 0 ? (
//                         <TableContainer component={Paper} sx={{ mb: 2 }}>
//                           <Table size="small">
//                             <TableHead>
//                               <TableRow>
//                                 <TableCell>Question</TableCell>
//                                 <TableCell>Answer</TableCell>
//                               </TableRow>
//                             </TableHead>
//                             <TableBody>
//                               {applicationAnswers.map((qa, idx) => (
//                                 <TableRow key={idx}>
//                                   <TableCell>{qa.question_text}</TableCell>
//                                   <TableCell>
//                                     {qa.answer &&
//                                     typeof qa.answer === "string" &&
//                                     qa.answer.startsWith("/uploads/") ? (
//                                       <Button
//                                         startIcon={<DownloadIcon />}
//                                         sx={{ ml: 1 }}
//                                         size="small"
//                                         onClick={() => {
//                                           const backendOrigin =
//                                             process.env.REACT_APP_API_URL ||
//                                             "http://localhost:8000";
//                                           let url = qa.answer;
//                                           if (
//                                             url &&
//                                             url.startsWith("/uploads/")
//                                           ) {
//                                             url =
//                                               backendOrigin.replace(/\/$/, "") +
//                                               url;
//                                           }
//                                           setModalFile({
//                                             url,
//                                             name: qa.question_text,
//                                           });
//                                           setModalOpen(true);
//                                         }}
//                                       >
//                                         View/Download
//                                       </Button>
//                                     ) : qa.answer ? (
//                                       qa.answer
//                                     ) : (
//                                       <em>None</em>
//                                     )}
//                                   </TableCell>
//                                 </TableRow>
//                               ))}
//                             </TableBody>
//                           </Table>
//                         </TableContainer>
//                       ) : (
//                         <Typography variant="body2" color="text.secondary">
//                           No questions answered.
//                         </Typography>
//                       )}
//                     </React.Fragment>
//                     {selectedApplication && (
//                       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
//                         <Typography variant="h6" sx={{ mb: 2 }}>
//                           Application Details
//                         </Typography>
//                         {/* ...existing details... */}
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           sx={{ mt: 2, mr: 2 }}
//                           onClick={handleOpenLogActivity}
//                         >
//                           Log Activity
//                         </Button>
//                         <Button
//                           variant="contained"
//                           color="success"
//                           sx={{ mt: 2, mr: 2 }}
//                           onClick={handleOpenEventModal}
//                         >
//                           Schedule Event
//                         </Button>
//                         <Button
//                           variant="outlined"
//                           color="secondary"
//                           sx={{ mt: 2 }}
//                           onClick={handleClearSelection}
//                         >
//                           Back to Candidates List
//                         </Button>
//                         <EventScheduleModal
//                           open={eventModalOpen}
//                           onClose={handleCloseEventModal}
//                           onSubmit={handleScheduleEvent}
//                           defaultAttendees={
//                             selectedApplication?.email
//                               ? [selectedApplication.email]
//                               : []
//                           }
//                           recruiterEmail={jobOrder?.recruiter_email || ""}
//                           panelOptions={jobOrder?.panel || []}
//                           jobOrder={jobOrder}
//                         />
//                         <Snackbar
//                           open={!!eventError}
//                           autoHideDuration={5000}
//                           onClose={() => setEventError("")}
//                           message={eventError}
//                           anchorOrigin={{
//                             vertical: "top",
//                             horizontal: "center",
//                           }}
//                           ContentProps={{ sx: { background: "#d32f2f" } }}
//                         />
//                         <Snackbar
//                           open={!!eventSuccess}
//                           autoHideDuration={4000}
//                           onClose={() => setEventSuccess("")}
//                           message={eventSuccess}
//                           anchorOrigin={{
//                             vertical: "top",
//                             horizontal: "center",
//                           }}
//                           ContentProps={{ sx: { background: "#388e3c" } }}
//                         />
//                         {/* Events Table */}
//                         {events.length > 0 && (
//                           <Box sx={{ mt: 4 }}>
//                             <Typography variant="h6" sx={{ mb: 2 }}>
//                               Events
//                             </Typography>
//                             <JobOrderEventsTable events={events} />
//                           </Box>
//                         )}
//                       </Paper>
//                     )}
//                     <Button
//                       variant="outlined"
//                       sx={{ mt: 2 }}
//                       onClick={handleClearSelection}
//                     >
//                       Back to Candidates List
//                     </Button>
//                   </>
//                 ) : (
//                   <Typography color="text.secondary">
//                     No application data found.
//                   </Typography>
//                 )}
//               </React.Fragment>
//             </Paper>
//           )}

//           <Dialog
//             open={modalOpen}
//             onClose={() => setModalOpen(false)}
//             maxWidth="xl"
//             fullWidth
//             PaperProps={{
//               sx: {
//                 minHeight: "70vh",
//                 minWidth: "70vw",
//                 p: 0,
//                 overflow: "auto",
//               },
//             }}
//           >
//             <DialogContent
//               dividers
//               sx={{
//                 height: "90vh",
//                 overflow: "auto",
//                 p: 0,
//                 position: "relative",
//               }}
//             >
//               <IconButton
//                 aria-label="close"
//                 onClick={() => setModalOpen(false)}
//                 sx={{
//                   position: "absolute",
//                   top: 8,
//                   right: 8,
//                   zIndex: 10,
//                   background: "rgba(6, 1, 1, 0.7)",
//                 }}
//                 size="large"
//               >
//                 <CloseIcon />
//               </IconButton>
//               {modalFile && modalFile.url ? (
//                 renderFileViewer(modalFile, docError, setDocError)
//               ) : (
//                 <Typography align="center" sx={{ mt: 4 }}>
//                   No file selected or file is missing.
//                 </Typography>
//               )}
//             </DialogContent>
//           </Dialog>
//         </Paper>
//       </Box>
//       {/* Global Snackbar for errors/successes */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={5000}
//         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//         message={snackbar.message}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         ContentProps={{
//           sx: {
//             background:
//               snackbar.severity === "error"
//                 ? "#d32f2f"
//                 : snackbar.severity === "success"
//                 ? "#388e3c"
//                 : undefined,
//           },
//         }}
//       />
//       {/* --- AI Resume Modal --- */}
//       <Dialog
//         open={aiModalOpen}
//         onClose={() => setAiModalOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           Resume & Job JSON for{" "}
//           {aiModalApplicant?.applicant_name || "Applicant"}
//         </DialogTitle>
//         <DialogContent dividers>
//           {aiModalLoading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minHeight: 180,
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : aiModalError ? (
//             <Typography color="error">{aiModalError}</Typography>
//           ) : aiModalJson ? (
//             <pre
//               style={{
//                 background: "#f5f5f5",
//                 padding: 16,
//                 borderRadius: 8,
//                 fontSize: 14,
//                 maxHeight: 400,
//                 overflow: "auto",
//               }}
//             >
//               {JSON.stringify(aiModalJson, null, 2)}
//             </pre>
//           ) : (
//             <Typography color="text.secondary">No data.</Typography>
//           )}
//           {/* AI Resume Analysis Result */}
//           {analyzeError && (
//             <Typography color="error" sx={{ mt: 2 }}>
//               {analyzeError}
//             </Typography>
//           )}
//           {analyzeResult && (
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                 AI Analysis Result
//               </Typography>
//               <pre
//                 style={{
//                   background: "#f0f7fa",
//                   padding: 12,
//                   borderRadius: 6,
//                   fontSize: 14,
//                   maxHeight: 300,
//                   overflow: "auto",
//                 }}
//               >
//                 {typeof analyzeResult === "string"
//                   ? analyzeResult
//                   : JSON.stringify(analyzeResult, null, 2)}
//               </pre>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setAiModalOpen(false)}>Close</Button>
//           <Button
//             onClick={handleSubmitAnalyze}
//             variant="contained"
//             disabled={analyzeLoading || !aiModalJson}
//           >
//             {analyzeLoading ? <CircularProgress size={20} /> : "Analyze Resume"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }


import React from "react";
import { Box, Chip, CircularProgress, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

function getScoreColor(score) {
  if (typeof score !== "number") return "#94a3b8";
  if (score <= 2) return "#ef4444";
  if (score <= 4) return "#f97316";
  if (score === 5) return "#eab308";
  if (score <= 7) return "#84cc16";
  if (score <= 9) return "#22c55e";
  return "#16a34a";
}

function getStatusStyles(status, dark, accent) {
  const key = String(status || "").toLowerCase();

  if (key === "completed") {
    return {
      bg: dark ? "rgba(34,197,94,0.18)" : "rgba(34,197,94,0.10)",
      fg: dark ? "#86efac" : "#15803d",
      border: dark ? "rgba(34,197,94,0.24)" : "rgba(34,197,94,0.18)",
    };
  }

  if (key === "processing" || key === "pending") {
    return {
      bg: dark ? "rgba(245,158,11,0.18)" : "rgba(245,158,11,0.12)",
      fg: dark ? "#fcd34d" : "#854d0e",
      border: dark ? "rgba(245,158,11,0.24)" : "rgba(245,158,11,0.18)",
    };
  }

  if (key === "failed" || key === "error" || key === "timeout") {
    return {
      bg: dark ? "rgba(239,68,68,0.18)" : "rgba(239,68,68,0.10)",
      fg: dark ? "#fca5a5" : "#b91c1c",
      border: dark ? "rgba(239,68,68,0.24)" : "rgba(239,68,68,0.18)",
    };
  }

  return {
    bg: dark ? alpha(accent, 0.14) : alpha(accent, 0.08),
    fg: accent,
    border: alpha(accent, 0.2),
  };
}

export function AIEvalStatusCell({ aiEvalStatus, appId }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const accent = dark ? "#fb923c" : "#f97316";

  const evalObj = aiEvalStatus?.[appId];

  if (!evalObj) {
    return (
      <Chip
        label="No evaluation"
        size="small"
        variant="outlined"
        sx={{
          borderRadius: 999,
          fontWeight: 700,
          color: "#94a3b8",
          borderColor: "#94a3b8",
        }}
      />
    );
  }

  if (evalObj.loading) {
    return <CircularProgress size={18} sx={{ color: accent }} />;
  }

  if (evalObj.error) {
    return (
      <Chip
        label="Error"
        size="small"
        variant="outlined"
        sx={{
          borderRadius: 999,
          fontWeight: 700,
          color: "#ef4444",
          borderColor: "#ef4444",
        }}
      />
    );
  }

  if (!evalObj.status) {
    return (
      <Chip
        label="No evaluation"
        size="small"
        variant="outlined"
        sx={{
          borderRadius: 999,
          fontWeight: 700,
          color: "#94a3b8",
          borderColor: "#94a3b8",
        }}
      />
    );
  }

  const styles = getStatusStyles(evalObj.status, dark, accent);

  return (
    <Chip
      label={evalObj.status}
      size="small"
      sx={{
        borderRadius: 999,
        fontWeight: 700,
        textTransform: "capitalize",
        background: styles.bg,
        color: styles.fg,
        border: `1px solid ${styles.border}`,
      }}
    />
  );
}

export function AIEvalScoreCell({ aiEvalStatus, appId }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const evalObj = aiEvalStatus?.[appId];

  if (!evalObj) return null;

  if (evalObj.loading) {
    return <CircularProgress size={18} sx={{ color: dark ? "#fb923c" : "#f97316" }} />;
  }

  if (typeof evalObj.match_score !== "number" || !isFinite(evalObj.match_score)) {
    return (
      <Typography
        variant="body2"
        sx={{ color: dark ? "#94a3b8" : "#64748b", fontWeight: 600 }}
      >
        NA
      </Typography>
    );
  }

  const color = getScoreColor(evalObj.match_score);

  return (
    <Box sx={{ display: "flex", alignItems: "center", minWidth: 92 }}>
      <Box
        sx={{
          flex: 1,
          height: 10,
          mr: 1,
          borderRadius: 999,
          overflow: "hidden",
          background: dark ? "rgba(255,255,255,0.08)" : "rgba(148,163,184,0.22)",
        }}
      >
        <Box
          sx={{
            width: `${Math.max(0, Math.min(10, evalObj.match_score)) * 10}%`,
            height: "100%",
            borderRadius: 999,
            background: color,
            transition: "width 0.5s ease",
          }}
        />
      </Box>

      <Typography
        variant="body2"
        sx={{
          minWidth: 26,
          textAlign: "right",
          fontWeight: 700,
          color,
        }}
      >
        {evalObj.match_score}
      </Typography>
    </Box>
  );
}